import { useState, useEffect } from 'react';

export function useOnboarding() {
  const [showOnboarding, setShowOnboarding] = useState(false);
  const [onboardingStep, setOnboardingStep] = useState(0);

  useEffect(() => {
    const hasSeenOnboarding = localStorage.getItem('swingslot_onboarding_complete');
    if (!hasSeenOnboarding) {
      setShowOnboarding(true);
    }
  }, []);

  const completeOnboarding = () => {
    localStorage.setItem('swingslot_onboarding_complete', 'true');
    setShowOnboarding(false);
  };

  return {
    showOnboarding,
    setShowOnboarding,
    onboardingStep,
    setOnboardingStep,
    completeOnboarding,
  };
}
